export default __webpack_public_path__ + "static/media/1.6a7d13c0.png";